import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ProvidingBonusForOrder } from '@cart/const';
import { IconTypes } from '@shared/v2';
import { SdvorIconComponent } from '../icon';

@Component({
  selector: 'sd-bonus-order-widget',
  imports: [SdvorIconComponent],
  templateUrl: './bonus-order-widget.component.html',
  styleUrls: ['./bonus-order-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BonusOrderWidgetComponent {
  readonly providingBonusForOrder = input.required<ProvidingBonusForOrder>();
  readonly iconTypes = IconTypes;
}
